export const buttonIcons = {
    plus: 'plus-fill',
    trash: 'trash',
    left: 'ico-chev-left',
    right: 'ico-chev-right',
    check: 'check',
    upload: 'ico-upload',
    edit: 'edit'
}
